import { Catalog } from "./catalog";

export class GoodType extends Catalog {
  validationKey: string = "good_type";
  notify: boolean;

  constructor(data:any) {
    super(data);
    this.notify = data.notify;
  }

  protected get saveProp(): string[] {
    return  super.saveProp.concat(["notify"]);
  }
}
